import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { ArrowUpDown } from 'lucide-react';
import type { DashboardStudentItem } from '@/types/dashboard';

interface AssignmentFiltersProps {
  status: string;
  studentId: string;
  sortOrder: string;
  students?: DashboardStudentItem[];
  onStatusChange: (value: string | null) => void;
  onStudentChange: (value: string | null) => void;
  onSortOrderToggle: () => void;
}

export function AssignmentFilters({
  status,
  studentId,
  sortOrder,
  students,
  onStatusChange,
  onStudentChange,
  onSortOrderToggle,
}: AssignmentFiltersProps) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <Select value={status} onValueChange={onStatusChange}>
        <SelectTrigger className="w-[140px]">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All</SelectItem>
          <SelectItem value="pending">Pending</SelectItem>
          <SelectItem value="completed">Completed</SelectItem>
          <SelectItem value="expired">Expired</SelectItem>
        </SelectContent>
      </Select>

      <Select value={studentId} onValueChange={onStudentChange}>
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="All students" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All students</SelectItem>
          {students?.map((s) => (
            <SelectItem key={s.id} value={s.id}>
              {[s.first_name, s.last_name].filter(Boolean).join(' ') || s.username || s.email || s.id.slice(0, 8)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Button variant="outline" size="icon" onClick={onSortOrderToggle}>
        <ArrowUpDown className="h-4 w-4" />
        <span className="sr-only">{sortOrder === 'asc' ? 'Ascending' : 'Descending'}</span>
      </Button>
    </div>
  );
}
